import { IS_NODE } from 'client/utils/environment';

let storage = {};

export const SecretsManagerStorage = {
  load(obj = {}) {
    storage = {
      ...storage,
      ...obj,
    };
    return this;
  },

  save(obj = {}) {
    return {
      ...obj,
      ...storage,
    };
  },

  get(key, defaultValue) {
    return storage[key] || defaultValue;
  },
};

if (!IS_NODE) {
  const secretsManager = window.EDM?.preloadedState?.secretsManager; // eslint-disable-line venom/no-prohibited-functions
  if (secretsManager) {
    SecretsManagerStorage.load(secretsManager);
  }
}
